import jobPostRoutes from './jobPostRoutes';
import deactivationRoutes from './deactivationRoutes';
import seekersDashboardRoutes from './seekersDashboardRoutes';
import exploreRoutes from './exploreRoutes';
import registrationRoutes from './registrationRoutes';
import bhBenefitsRoutes from './bhBenefitsRoutes';
import searchRoutes from './searchRoutes';
import shareJobsRoutes from './shareJobsRoutes';
import interviewRequestRoutes from './interviewRequestRoutes';

const seekerRoutes = [
  ...jobPostRoutes,
  ...seekersDashboardRoutes,
  ...deactivationRoutes,
  ...searchRoutes,
  ...bhBenefitsRoutes,
  ...interviewRequestRoutes,
  ...exploreRoutes,
  ...registrationRoutes,
  ...shareJobsRoutes,
];

export default seekerRoutes;
